/* Material */
import Alert from '@mui/material/Alert'
import useStyles from '../styles'
import presentation from '../../../ProductPresentation.module.css'

/* Material-Icons */
//import LocalShippingIcon from '@mui/icons-material/LocalShipping'

/* Components */
import NoBr from 'src/components/js_elements/NoBr'

/* Config */
import config from 'src/config'
import { useProductInquiryConfig } from 'src/context/ProductInquiryContext'

const { stockDeliveryTime } = config

interface Props {
  deliverytime?: number
  stockDeliverytime?: number
  inquiredQty: number
  stockQty?: number
  onlyStock?: true
  inquireOnly?: boolean
  compact?: boolean
}

const DeliverytimeDisplay: React.FC<Props> = ({
  deliverytime,
  stockDeliverytime,
  inquiredQty,
  stockQty = 0,
  onlyStock,
  inquireOnly,
  compact = false,
}) => {
  const classes = useStyles()
  const alertClassName = compact ? presentation.availability : classes.deliverytimeDisplay
  const productInquiry = useProductInquiryConfig()
  const resolvedStockDeliverytime = stockDeliverytime ?? stockDeliveryTime

  if (inquireOnly) {
    return <Alert severity='info' className={alertClassName}>
      {productInquiry.detailNotice}
    </Alert>
  }

  /* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
  /* Artikel nur noch Lagerware */
  if (onlyStock) {
    if (stockQty <= 0) {
      return <Alert
        severity='error'
        className={alertClassName}
      >
        Aktuell nicht am Lager. <br />
        Nur solange der Vorrat reicht!
      </Alert>
    }

    return <Alert 
      severity={stockQty <= config.onlyStockWarningLimit ? 'error' : 'success'}
      className={alertClassName}
    >
      Noch {stockQty} x am Lager <br />
      Nur solange der Vorrat reicht! <br />
      Lieferzeit: {resolvedStockDeliverytime} Werktage *²
    </Alert>
  }

  /* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
  /* Artikel Bestellbar und auf Lager */
  if (stockQty) {
    if (stockQty >= inquiredQty)
      return <Alert severity='success' className={alertClassName}>
        <NoBr>{stockQty} x am Lager</NoBr> <br /> 
        <NoBr>Lieferzeit: {resolvedStockDeliverytime} Werktage *²</NoBr>
      </Alert>
    else
      return <Alert severity='warning' className={alertClassName}>
        <NoBr>{stockQty} x am Lager, </NoBr>
        <NoBr>Lieferzeit: {resolvedStockDeliverytime} Werktage *²</NoBr>
        <br />
        <NoBr>{inquiredQty - stockQty} x</NoBr> Bestellware · ca.{' '}
        <NoBr>{deliverytime} Werktage *²</NoBr>
      </Alert>
  }

  /* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
  /* Ganz normale Lieferzeit */
  if (compact) return <Alert severity='info' className={alertClassName}>
    Bestellware · ca. <NoBr>{deliverytime} Werktage *²</NoBr>
  </Alert>

  return <Alert severity='info' className={alertClassName}>
    <strong>Bestellware – wir kümmern uns darum!</strong>
    <br />
    Dieser Artikel wird für Sie bei unserem Hersteller bestellt. Bitte planen Sie
    eine Lieferzeit von ca.{' '}
    <NoBr>{deliverytime} Werktagen</NoBr> ein. *²
  </Alert>
  /* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
  
}

export default DeliverytimeDisplay
